import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Table,
  Label,
  CardTitle,
  CardSubtitle,
  Spinner,
} from "reactstrap";
import { AvForm, AvField, } from "availity-reactstrap-validation";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import { convertToLowestUnit, GetUpdatedDelivered, formatUnitsForReport } from "../../../helpers/units";
import { useRef } from "react";
import moment from "moment";
import EnterQuantityModal from "../../EnterQuantityModal";

const PlaceOrder = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const storeId = localStorage.getItem("store_id")
  const [selectedStore, setSelectedStore] = useState("");
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("")

  const refSelectedItem = useRef(null);
  const handleDeleteRow = (batch) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.item_id !== batch.item_id);
      return updatedCartItems;
    });
  };


  const columns_cartitems = [
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    // {
    //   dataField: "batch",
    //   text: props.t("Batch"),
    // },
    // {
    //   dataField: "expiry_date",
    //   text: props.t("Expiry Date"),
    //   formatter: (cell, row) => {
    //     return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';
    //   },
    // },
    {
      dataField: "available",
      text: props.t("Available"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.available, row.unit_levels)
      },
    },
    {
      text: props.t("Order Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            {/* <Row>
              <Col lg={6} md={6} className="text-left"> */}
            {formatUnitsForReport(row.quantity)}
            {/* </Col>
              <Col lg={6} md={6}> */}
            {/* 
                <Button
                  className="btn btn-success waves-effect waves-light btn-sm"
                  onClick={() => {
                    setSelectedItems(row)
                    setEditUnitModal(!editUnitModal);
                  }}
                >
                  <i class="mdi mdi-edit"></i>
                  {props.t("Edit")}
                </Button> */}


            {/* </Col>
            </Row> */}

          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const handleAddUnits = async (quantity) => {
    const { unit_levels, unit_for_max_order, max_order_limit } = selectedItem
    let maxLimit = convertToLowestUnit(unit_levels, [{ unit: unit_for_max_order, value: max_order_limit }]);
    let totalEntered = convertToLowestUnit(unit_levels, quantity)
    if (totalEntered > maxLimit && selectedStore?.type === "Branch") {
      showNotification(`can not add more than <strong> ${max_order_limit + " " + unit_for_max_order} </strong>`, "Warning")
      return
    }
    var new_array_items = JSON.parse(JSON.stringify(cartItems));
    const existing_item = new_array_items.filter(function (item) {
      return item.item_id === selectedItem._id;
    });
    let convertedQuantity = GetUpdatedDelivered(quantity, selectedItem?.unit_levels)
    if (existing_item.length > 0) {
      showNotification(
        props.t("This item is already added."),
        props.t("Warning")
      );
    } else if (selectedItem) {
      let item_to_add = {};
      item_to_add.item_id = selectedItem?._id;
      item_to_add.name = selectedItem?.name;
      item_to_add.category = selectedItem?.category;
      item_to_add.sub_category = selectedItem?.sub_category;
      item_to_add.brand = selectedItem?.brand;
      item_to_add.available = selectedItem?.store_available;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem?.unit_levels.map(({ unit, value }) => ({ unit, value }));
      setCartItems([...cartItems, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem("");
      setSelectedRowsUnit([]);
      // refSelectedItem.current.select.clearValue();
    } else {
      showNotification(props.t("Something went wrong."), props.t("Error"));
    }
  };

  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
setIsDisabled(true)
      const object = {
        requestedItems: cartItems,
        requestedToStoreId: selectedStore && selectedStore._id,
        requestedFromStoreId: storeId,
      };
      // console.log(object,"Payload");
      // return
      let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/create_order_request";
      let response = await postSubmitForm(url, object);
      if (response.status === 1) {
        setIsDisabled(false)
        setCartItems([]);
        setSelectedItem("");
        // refSelectedItem.current.select.clearValue();
        showNotification(response.message, "Success");
        // window.location.reload()
      } else if (response.status === 2) {
        setIsDisabled(false)
        showNotification(response.message, "Warning");
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error.message, "Error");
    }
  };

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedItem("")
    setSelectedRowsUnit([])
  }

  return (
    <React.Fragment>

      <Row>

        <Col lg={12}>
          <Card>
            <CardBody >
              <CardTitle>{props.t("Add New Order")}</CardTitle>
              <CardSubtitle>{props.t("Enter the following details to place order for items")}</CardSubtitle>
              <AvForm>
                <Row className="mt-2">

                  <Col lg={4} >
                    <Label>{props.t("To")}</Label>
                    <Select
                      options={props.allStores}
                      placeholder={props.t("None")}
                      onChange={(se) => { setSelectedStore(se); setSelectedItem(""); props.onStoreSelect(se) }}
                      value={selectedStore}
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  </Col>

                  {selectedStore && (
                    <Col lg={4} >
                      <Label>{props.t("Item")}</Label>
                      <Select
                        options={props.allItems}
                        placeholder={props.isLoadingItems ? props.t("Loading...") : props.t("None")}
                        isLoading={!!props.isLoadingItems}
                        isDisabled={!!props.isLoadingItems}
                        onChange={(se) => { setSelectedItem(se) }}
                        classNamePrefix="select2-selection"
                        value={selectedItem}
                        className="basic-single"

                      />
                    </Col>
                  )}

                  {selectedItem && (
                    <>
                      <Col lg={2}>
                        <br />
                        <Label>{`${selectedStore?.name} ${props.t("Available")}`}</Label>
                        <br />
                        <Label>
                          {formatUnitsForReport(selectedItem?.available, selectedItem?.unit_levels)}
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <br />
                        <Label>Threshold Quantity</Label>
                        <br />
                        <Label>
                          {selectedItem?.threshold +
                            " " +
                            selectedItem?.unit_for_threshold}
                        </Label>
                      </Col>
                    </>
                  )}

                </Row>
              
                    {selectedItem && (
                      <Row>
                        <Col lg={4}>
                          <FormGroup className="mb-0 mt-3">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                className="mr-1 btn-success btn "
                                onClick={() => setSelectUnitModal(!selectUnitModal)}
                              >
                                {props.t("Enter Quantity")}
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    )}
                    </AvForm>
              <hr />

              {cartItems.length > 0 && (
                <Row className="mt-5">
                  <Col lg={12}>


                    <ToolkitProvider
                      bootstrap4
                      keyField="item_id"
                      data={cartItems}
                      columns={columns_cartitems}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                    <AvForm onValidSubmit={handleValidSubmit}>
                      <Row>
                        {/* <Col lg={6}>
                                    <AvField
                                      name="remarks"
                                      value={remarks}
                                      onChange={(e) => {
                                        setRemarks(e.target.value);
                                      }}
                                      label={props.t("Remarks")}
                                      placeholder={props.t("Enter Remarks")}
                                      type="textarea"
                                    />
                                  </Col> */}
                        <Col lg={12}>
                          <hr />
                          <FormGroup className="mb-0 text-left">
                            <div>
                              <Button
                                type="submit"
                                disabled={isDisabled}
                                color="primary"
                                style={{ width: '140px' }} 
                                className="mr-1"
                              >
                                {isDisabled ? <Spinner size="sm" /> : props.t("Place Order")} 
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>

                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>




      {/* Add unit modal  */}
      <EnterQuantityModal
        isOpen={selectUnitModal}
        toggle={handleCloseModal}
        onSubmit={handleAddUnits}
        item={selectedItem}
        checkLimitFor={""}
      />


    </React.Fragment>
  );
};
export default withNamespaces()(PlaceOrder);

